export { default } from './CarsStockDesktop';
